import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import { crm } from "../../../../../theme";
import DocumentUpload from "../../../../../components/DocumentUpload";
import { useRef, useState } from "react";
import { importCompanies } from "../../../../../services/companyService";
import { importSuppliers } from "../../../../../services/supplierService";

const ImportModal = ({
  isOpen,
  onClose,
  getSavedCompanies,
  isSupplier = false,
}: {
  isOpen: boolean;
  onClose: () => void;
  getSavedCompanies: () => void;
  isSupplier?: boolean;
}) => {
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState<File>();
  const inputRef = useRef(null);
  const toast = useToast();

  const startMigration = async () => {
    setLoading(true);
    if (file) {
      const response = isSupplier
        ? await importSuppliers(file)
        : await importCompanies(file);
      if (response) {
        getSavedCompanies();
        toast({
          title: "Importação realizada.",
          status: "success",
          duration: 4000,
          isClosable: true,
        });
      }
    }
    setLoading(false);
  };

  return (
    <Modal isCentered {...{ isOpen, onClose }} size="xl">
      <ModalOverlay backdropFilter="blur(2px)" bg="blackAlpha.600" />
      <ModalContent borderRadius="16px" boxShadow="0 12px 32px rgba(16,24,40,0.18)">
        <ModalHeader>
          <Flex justifyContent="space-between">
            <Heading size="md" fontWeight="normal" mb="8px">
              Importar
            </Heading>
            <CloseButton onClick={onClose} />
          </Flex>
        </ModalHeader>
        <ModalBody>
          <Text mb="24px">
            {isSupplier
              ? `O excel deve ter uma coluna com o exato seguinte nome: "Nome"`
              : `O excel deve ter duas colunas com os exatos seguintes nomes: "Nome"
            e "Cnpj"`}
          </Text>
          <DocumentUpload
            inputRef={inputRef}
            file={file}
            setFile={setFile}
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            onFileChange={(e) => setFile(e)}
            w="100%"
            py="20px"
          />
        </ModalBody>
        <ModalFooter borderTop={`1px solid ${crm.border}`}>
          <Flex justifyContent="flex-end" gap="12px">
            <Button
              variant="outline"
              borderColor={crm.border}
              color={crm.brand}
              borderRadius="10px"
              _hover={{ bg: crm.brandSoft, borderColor: crm.brand }}
              onClick={onClose}
            >
              Cancelar
            </Button>
            <Button
              isLoading={loading}
              isDisabled={!file}
              backgroundColor={crm.brand}
              color="white"
              borderRadius="10px"
              _hover={{ backgroundColor: crm.brandDark }}
              onClick={() => startMigration()}
            >
              Importar
            </Button>
          </Flex>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ImportModal;
